import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  searchInput: {
    border: `1px solid ${theme.palette.colors.grey}`,
    borderRadius: '5px',
    padding: '0.125rem 0.5rem',
    fontWeight: 400,
    outline: 0,
    height: '2.5rem',
    width: '100%',
    background: '#fff',
  },
  chevronStyle: {
    fontSize: '1.3em',
    color: theme.palette.colors.grey,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  searchStyle: {
    fontSize: '1.3em',
    color: '#000429',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  title: {
    fontSize: '24px',
  },
  tooltip: {
    fontSize: '1.2em',
  },
  helpIcon: {
    margin: '-0.25rem 0 0 0.5rem',
  },
  selectedGenCounter: {
    padding: '0 8px',
    lineHeight: 2,
    fontWeight: 'bold',
  },
}));

export default useStyles;
